export const INTERCOM_TARGET_PREFIX = 'createChallenge';

export const BLANK_CHALLENGE_THEME_NAME = 'blank';
